import { CategoryDetailsPageContext } from "@eisinc/Overrides/Pages/CategoryDetailsPage";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import widgetModule, { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";

import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css``,
};

widgetModule.definition.allowedContexts = [ProductListPageContext, CategoryDetailsPageContext];

export default widgetModule;
